import React from "react";
import clsx from "clsx";
import PanaLogo from "./PanaLogo";
import { connect, useSelector } from "react-redux";
import { DefaultButton } from "@fluentui/react";
import { FC } from "react";
import { FontIcon } from "@fluentui/react";
import { getTheme } from "@fluentui/react";
import { IButtonStyles } from "@fluentui/react";
import { Icon } from "@fluentui/react";
import { LineHandling } from "../../models";
import { LineHandlingApi } from "../../api/lineHandlingApi";
import { mergeStyleSets } from "@fluentui/react";
import { MessageBar } from "@fluentui/react";
import { MessageBarType } from "@fluentui/react";
import { PrimaryButton } from "@fluentui/react";
import { State } from "../../store";
import { SVLModel } from "../../models";
import { toNominationNo } from "../../services/Helper";
import { trimEmpty } from "../../services/Helper";
import { useEffect } from "react";
import { useState } from "react";
import * as OfflineDataStore from "../../store/OfflineDataStore";

type ISVLProps = {
  lineHandling: LineHandling;
  onCancel(): void;
  onSuccess(nominations: SVLModel[]): void;
  onOfflineUpdate(lineHandlingNo: string, nominations: SVLModel[]): void;
};

const theme = getTheme();
const classes = mergeStyleSets({
  container: {
    padding: 12
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  content: {
    maxHeight: 520,
    overflow: "auto"
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: 12,
    gap: 12,
    color: "#7C7777"
  },
  title: {
    fontSize: 18,
    color: "#00447E",
    fontWeight: "bold"
  },
  itemContainer: {
    background: "#FAFAFA",
    border: "1px dashed #E2E6E8",
    padding: 10,
    marginBottom: 10,
    color: "#7C7777",
    borderRadius: 5
  },
  itemTitle: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#4C4C4C",
    display: "block"
  },
  fieldLabel: {
    display: "block",
    marginTop: 12
  },
  fieldInputBox: {
    border: "1px solid #D8DFE6",
    width: "100%",
    padding: "5px 10px",
    selectors: {
      [":focus"]: {
        border: "1px solid #008cc0"
      }
    }
  },
  cancelButton: {
    background: "#F2F4F6",
    borderRadius: 2,
    border: "unset",
    flexGrow: 1,
    height: 42
  }
});
const iconButtonStyles: Partial<IButtonStyles> = {
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: "auto",
    marginTop: "4px",
    marginRight: "2px"
  },
  rootHovered: {
    color: theme.palette.neutralDark
  }
};

const shipVaporLines: string[] = ["N/A", "N2 Reg", "Vapor Line"];
const ShipVaporLineModal: FC<ISVLProps> = (props: ISVLProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [canSave, setCanSave] = useState(false);
  const [completedCount, setCompletedCount] = useState(0);
  const [nominations, setNominations] = useState<SVLModel[]>([]);
  const [errorMessage, setErrorMessage] = useState<string>();

  const countCompleted = (_nominations: SVLModel[]) => {
    const _completedCount = _nominations.filter(
      f =>
        f.shipVaporLine !== undefined &&
        f.shipVaporLine !== null &&
        f.shipVaporLine !== ""
    ).length;
    setCompletedCount(_completedCount);
    setCanSave(
      props.lineHandling !== undefined &&
        _completedCount === props.lineHandling.nominations.length
    );
  };

  const setShipVaporLine = (nomination: SVLModel, svl: string) => {
    nomination.shipVaporLine = svl;
    if (svl !== "Vapor Line") {
      nomination.shipVaporLineDescription = "";
    }

    const _nominations = [
      ...nominations.filter(f => f.nominationNo !== nomination.nominationNo),
      nomination
    ];
    setNominations(_nominations.sort((a, b) => a.order - b.order));
    countCompleted(_nominations);
  };

  const setShipVaporLineDescription = (
    nomination: SVLModel,
    svlDescription: string
  ) => {
    nomination.shipVaporLineDescription = svlDescription;

    const _nominations = [
      ...nominations.filter(f => f.nominationNo !== nomination.nominationNo),
      nomination
    ];
    setNominations(_nominations.sort((a, b) => a.order - b.order));
  };

  const saveChanges = async () => {
    try {
      setIsLoading(true);

      const lineHandlingNo = props.lineHandling.lineHandlingNo;

      const response = await LineHandlingApi.updateShipVaporLineAsync(
        lineHandlingNo,
        nominations,
        () => props.onOfflineUpdate(lineHandlingNo, nominations)
      );
      if (response.ok) {
        setIsSuccess(true);
        setTimeout(() => {
          props.onSuccess(nominations);
        }, 1000);
      } else if (response.status === 399) {
        setIsSuccess(true);
        setTimeout(() => {
          props.onSuccess(nominations);
        }, 1000);
      }
    } catch (ex) {
      setErrorMessage("Unable to save changes. Please try to reconnect.");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const _nominations = props.lineHandling.nominations.map(
      (nom, index) =>
        ({
          order: index,
          nominationNo: nom.nominationNo,
          product: nom.product,
          customer: nom.customer,
          shipVaporLine: nom.shipVaporLine,
          shipVaporLineDescription: nom.shipVaporLineDescription
        } as SVLModel)
    );
    setNominations(_nominations);
    countCompleted(_nominations);
  }, []);

  return (
    <div className={classes.container}>
      {isSuccess && (
        <div style={{ padding: 44, textAlign: "center" }}>
          <PanaLogo />
          <label className={classes.title} style={{ margin: 24 }}>
            Nomination details updated
          </label>
        </div>
      )}

      {!isSuccess && (
        <>
          <div className={classes.header}>
            <label className={classes.title}>Edit Required Nominations</label>
          </div>
          <div className={clsx(classes.content, "custom-scroll")}>
            {nominations.length > 0 &&
              nominations
                .sort((a, b) => (a.nominationNo > b.nominationNo ? 1 : -1))
                .map(nomination => (
                  <div
                    key={nomination.nominationNo}
                    className={classes.itemContainer}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between"
                      }}
                    >
                      <label
                        htmlFor="txt-ship-vapor-line"
                        className={classes.itemTitle}
                      >
                        {toNominationNo(nomination.nominationNo)} -
                        {nomination.product}
                      </label>
                      {nomination.shipVaporLine !== undefined &&
                        nomination.shipVaporLine !== null &&
                        nomination.shipVaporLine !== "" && (
                          <Icon
                            iconName="CompletedSolid"
                            style={{ color: "#4CAF50" }}
                          />
                        )}
                    </div>
                    <label>{nomination.customer}</label>

                    <label className={classes.fieldLabel}>
                      Ship Vapor Line
                    </label>
                    <div className="btn-menu-group">
                      {shipVaporLines.map(svl => (
                        <div
                          key={svl}
                          className={clsx(
                            "btn-menu",
                            nomination.shipVaporLine === svl &&
                              "btn-menu-selected"
                          )}
                          onClick={() => setShipVaporLine(nomination, svl)}
                          style={{ marginLeft: "2px", marginRight: "2px" }}
                        >
                          <FontIcon
                            iconName={
                              nomination.shipVaporLine === svl
                                ? "RadioBtnOn"
                                : "RadioBtnOff"
                            }
                            style={{ fontSize: "12px" }}
                          />
                          &nbsp;
                          {svl}
                        </div>
                      ))}
                    </div>

                    {nomination.shipVaporLine === "Vapor Line" && (
                      <>
                        <label>Ship Vapor Line description</label>
                        <input
                          id="txt-ship-vapor-line-description"
                          className={classes.fieldInputBox}
                          value={nomination.shipVaporLineDescription}
                          onChange={e =>
                            setShipVaporLineDescription(
                              nomination,
                              `${
                                nomination.shipVaporLine === "Vapor Line"
                                  ? trimEmpty(e.target.value)
                                  : ""
                              }`
                            )
                          }
                          onBlur={e =>
                            setShipVaporLineDescription(
                              nomination,
                              e.target.value.trim()
                            )
                          }
                          disabled={isLoading}
                          maxLength={150}
                        />
                      </>
                    )}
                  </div>
                ))}

            {errorMessage && (
              <div style={{ marginTop: "10px" }}>
                <MessageBar
                  messageBarType={MessageBarType.error}
                  onDismiss={() => setErrorMessage(undefined)}
                >
                  {errorMessage}
                </MessageBar>
              </div>
            )}
          </div>
          <div
            className={classes.footer}
            style={{ borderTop: "1px solid #E2E6E8" }}
          >
            <span>Completed</span>
            <span>
              {completedCount} / {props.lineHandling.nominations.length}{" "}
              Nominations
            </span>
          </div>
          <div className={classes.footer}>
            <PrimaryButton
              type="submit"
              className={`btn-prim`}
              disabled={isLoading || !canSave}
              style={{ flexGrow: 1, height: 42 }}
              onClick={saveChanges}
            >
              {isLoading ? "Saving Nominations.." : "Save"}
            </PrimaryButton>
            <DefaultButton
              onClick={props.onCancel}
              disabled={isLoading}
              className={`${classes.cancelButton} btn-def`}
            >
              Cancel
            </DefaultButton>
          </div>
        </>
      )}
    </div>
  );
};
export default ShipVaporLineModal;
